<template>
  <button
    :class="`zo-close fal fa-times ${iconSize} fa-fw`"
    :title="$t('general.actions.close')"
    :qa-id="qaId"
    :data-testid="qaId"
    @click.prevent="clicked"
  />
</template>

<script>
export default {
  props: {
    qaId: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: 'fa-lg',
    },
  },
  emits: ['clicked'],
  methods: {
    clicked(event) {
      this.$emit('clicked', event);
    },
  },
};
</script>
